export default __webpack_public_path__ + "static/media/login.a047446d.svg";